import styled from "@emotion/styled";
import {
  createPolymorphicComponent,
  TextInput,
  type TextInputProps,
} from "@mantine/core";

export const _StyledWeek = styled(TextInput)`
  .mantine-Input-input {
    text-align: center;
    width: 60px;
    padding: 0;
  }

  .mantine-NumberInput-wrapper {
    width: 110px;
    white-space: nowrap;
  }
`;

export const StyledWeek = createPolymorphicComponent<"input", TextInputProps>(
  _StyledWeek,
);
